module.exports = __webpack_public_path__ + "media/images/icons/filled/left-square-7f3385f70946efc8ad6852e3cdfb1f47.svg";